import React from "react";
import { igemLogoDark } from "../../../../assets/icons";
import "./styles.scss";

export const Landing = (): JSX.Element => (
  <div className="landing">
    <div className="landing-wrapper">
      <img src={igemLogoDark} alt="igem-logo" />
      <h3 className="upper-title">Opening Weekend</h3>
      <h1>Festival</h1>
      <div className="landing-spacer">
        <div />
        <div />
        <div />
      </div>
      <div className="landing-date">
        <h6>May 15-16, 2021</h6>
      </div>
    </div>
  </div>
);
